import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors } from "@material-ui/core";
import { styleNo } from "../../../Invs/ShareFunctionsPrint";

export function Totals({infoData}) {
  const cls = useRptAF();
  return (
    <Grid
      container
      lg={12}
      md={12}
      className={cls.rootBdydown}
      style={{ paddingBottom: 5, backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular" }}
    >
      <Grid container xs={12} /*className={cls.rootchip}*/ style={{
        paddingBottom: 5,
        backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular",
        border: "solid 1px",
        padding: "0.3rem 0.1rem 0.3rem 0.1rem",
        borderRadius: "0px 0px 5px 0px"
      }}>

        <Grid item xs={3} className={[cls.chipVMU]}>
          {"إجمالي عدد الأصناف"}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {infoData.tot.totval}
        </Grid>
        <Grid item xs={3} className={[cls.chipVMU]}>
          {"إجمالي التكلفة"}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {infoData.tot.totTaqlfa}
        </Grid>
      </Grid>

    </Grid>
  );
}

export function TotalsUn({infoData}) {
  const styf = { fontWeight: "1200" };
  const cls = useRptAF();
  const totals = infoData.tot;

  const styleE={
      border: "solid 1px ",
      borderColor: "black",
      textAlign: "center",
      padding: 2,
      fontSize: "0.9rem",
      color: "black",
      fontWeight: "bold",
  };
  const styleTo={
      border: "solid 1px ",
      borderColor: "black",
      textAlign: "center",
      fontSize: "0.9rem",
      fontWeight: "bold",
  };
  return (
      <Grid item container className={cls.rootBdy}>
    <Grid item container className={cls.rootBdyup}>
      <Grid container lg={12} md={12} className={cls.rootBdydown}>
      <Grid container xs={12} /*className={cls.rootchip}*/>
        <Grid item xs={3} style={styleE}>
          {"إجمالي عدد السجلات"}
        </Grid>
        <Grid item xs={3} style={styleE}>
          {"إجمالي الكميات"}
        </Grid>
        <Grid item xs={3} style={styleE}>
          {"إجمالي التكلفة"}
        </Grid>
        <Grid item xs={3} style={styleE}>
          {"إجمالي البيع"}
        </Grid>
      </Grid>
      <Grid container xs={12} /*className={cls.rootchip}*/>
        <Grid item xs={3} style={styleTo}>
          {totals.cntTotal?.toFixed(2)}
        </Grid>
        <Grid item xs={3}  style={styleTo}>
          {totals.qtyTotal?.toFixed(2)}
        </Grid>
        <Grid item xs={3}  style={styleTo}>
          {totals.costTotal?.toFixed(2)}
        </Grid>
        <Grid item xs={3}  style={styleTo}>
          {totals.totNetTotal?.toFixed(2)}
        </Grid>
      
      </Grid>
    </Grid>
    </Grid>
    </Grid>
  );
}
function BodyJard({ data, isLast ,typePrint,infoData}) {

  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "14px",
    width: "32%",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };

  var columns = [
    { title: "م", field: "no", cellStyle: styleNo },
    { title: "الباركود", field: "barcode" },
    { title: "الصنف", field: "Name_Item", cellStyle: cellS },
    { title: "الرصيد", field: "Balance" },
    { title: "متوسط التكلفة", field: "cost" },
    { title: "إجمالي التكلفة", field: "sumCost_item" },
    { title: "إجمالي الوارد", field: "Income" },
    { title: "إجمالي المباع", field: "Outcome" },
  ];

  var columns2 = [
    { title: "م", field: "no", cellStyle: styleNo },
    { title: "رقم الباركود", field: "barcode" },
    { title: "الصنف", field: "Name_Item", cellStyle: cellS },
    { title: "الرصيد", field: "Balance" },
    { title: "Group", field: "Name_Group" },
    { title: "متوسط التكلفة", field: "cost" },
    { title: "إجمالي التكلفة", field: "sumCost_item" },
  ];
  var columnsUn = [
    { title: "م", field: "no", cellStyle: styleNo },
    { title: "الباركود", field: "barcode" },
    { title: "الصنف", field: "Name_Item", cellStyle: cellS },
    { title: "الرصيد", field: "dec_Qtys" },
    { title: "متوسط التكلفة", field: "Csot" },
    { title: "إجمالي التكلفة", field: "Sum_Cost" },
    { title:"سعر البيع", field: "sale_price" },
    { title:"اجمالي سعر البيع", field: "Sum_sale_price" },
  ];

  const data2 = data.map((row) => {
    return {
      ...row,
      balance: parseFloat(row.balance).toFixed(2),
      cost: parseFloat(row.cost).toFixed(2),
      sumCost_item: parseFloat(row.sumCost_item).toFixed(2),
      Income: parseFloat(row.Income).toFixed(2),
      Outcome: parseFloat(row.Outcome).toFixed(2),
      Csot: parseFloat(row?.Csot).toFixed(2),
      Sum_Cost: parseFloat( row?.Sum_Cost).toFixed(2),
      sale_price: parseFloat(row?.sale_price).toFixed(2),
      Sum_sale_price:parseFloat(row?.Sum_sale_price).toFixed(2),
    };
  });

  return (
    <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
      <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none" ,width:"100%",tableLayout:"fixed"}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={typePrint!=1?columnsUn: infoData.kind == 2 ? columns2 : columns}
            data={data2}
          />
          {isLast && (typePrint==1?<Totals infoData={infoData}  />:  <TotalsUn infoData={infoData}/>)}
        </Grid>
      </Grid>


    </Grid>
  );
}

export default BodyJard;
